import React, { useState } from 'react';
import { Toast } from 'primereact/toast';
import { api } from '../../../../_services/api/api';
import { confirmDialog, ConfirmDialogProps } from 'primereact/confirmdialog';
import { confirmPopup } from 'primereact/confirmpopup';
import { AdminEntityRole } from '../../../../_models/admin/admin-entity-role';
import { clearAdminTaxonomy } from '../../../../_services/api-resources/admin-taxonomy';
import { DialogProps } from 'primereact/dialog';


interface HideRoleButtonProps {
    entityRole: AdminEntityRole;
    onHide: () => void;
    toast: React.RefObject<Toast>;
    hasChanges: boolean;
    disabled?: boolean;
    saveChanges: () => Promise<boolean>;
}

export function HideRoleButton(props: HideRoleButtonProps) {
    const [isDeleting, setIsDeleting] = useState(false);

    const hide = () => confirmDialog({
        message: (
            <dl>
                <dt className="mt-3">Are you sure you want to hide this role?</dt>
            </dl>
        ),
        header: 'Hide Role',
        icon: 'fal fa-question-circle text-primary',
        accept: () => {
            setIsDeleting(true);
            api.post.setRoleVisibility({
                id: props.entityRole.id,
                visibility: false
            }).then(result => {
                if (result?.success) {
                    clearAdminTaxonomy();
                    props.onHide();
                    setIsDeleting(false);
                } else {
                    props.toast.current?.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Unable to hide role',
                    });
                    setIsDeleting(false);
                }
            });
        },
        blockScroll: true,
        draggable: false
    } as ConfirmDialogProps & DialogProps);

    const save = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'If you proceed your changes will be saved.  Proceed?',
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
                if (await props.saveChanges()) {
                    hide();
                }
            }
        });
    }

    const onHideClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (props.hasChanges) {
            save(event);
        } else {
            hide();
        }
    };

    if (!props.entityRole.id) {
        return null;
    }

    return <button type="button" className="btn btn-outline-white text-danger"
        onClick={onHideClick} disabled={props.disabled || isDeleting}
    >
        {isDeleting ?
            <i className="fad fa-spin fa-spinner"></i>
            : <><i className="fas fa-eye-slash mr-2"></i> Hide Role</>}

    </button>;
}
